<template>
  <el-select
    ref="select"
    :value="value"
    filterable
    clearable
    remote
    :value-key="valueKey"
    :nameKey="nameKey"
    :clearNoExistValue="true"
    :remote-method="remoteMethod"
    :loading="loading"
    :multiple="multiple"
    :multiple-limit="multipleLimit"
    :allow-create="allowCreate"
    @change="handleChange"
    @focus="handleFocus"
    >
    <el-option
      v-for="item in options"
      :key="item[valueKey]"
      :label="item[nameKey]"
      :value="item">
    </el-option>
  </el-select>
</template>

<script>
import {getCategoryPropsValue} from '@/servers/prod/center/kuaishou.js'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    propId: {
      require: true
    },
    propName: {
      require: true
    },
    categoryId: {
      require: true
    },
    valueKey: {
      type: String,
      default: 'propValue'
    },
    nameKey: {
      type: String,
      default: 'propValue'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    multipleLimit: {
      type: Number,
      default: 0
    },
    allowCreate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      loading: false
    }
  },
  methods: {
    handleFocus() {
      this.remoteMethod()
    },
    handleChange(v) {
      let newV = null;
      if(this.multiple) {
        newV = v.map(item => {
          return this.customValueHandle(item)
        })
      } else {
        newV = this.customValueHandle(v)
      }
      this.$emit('change', newV)
    },
    // 如果是自定义的值，则重组下结构
    customValueHandle(v) {
      if(typeof v === "string") {
        return {
          propId: this.propId,
          propValueName: this.propName,
          propValue: v,
        }
      } else {
        return v
      }
    },
    async remoteMethod(query = '') {
      this.loading = true
      let res = await getCategoryPropsValue({
        propValue: query,
        page: 1,
        categoryId: this.categoryId,
        propId: this.propId
      })
      this.options = (res && res.propValues) ? res.propValues.map(item => {
        return {
          ...item,
          propId: this.propId,
          propValueName: this.propName
        }
      }) : []
      this.loading = false
    }
  },
  watch: {
    value: {
      handler() {
        // 属性规则变更导致(原来是单选属性，变更为了多选属性，但是填充值没有更改)，需要做下兼容
        if(this.multiple && this.value && Object.prototype.toString.call(this.value) === '[object Object]') {
          this.$emit('change', [{...this.value}])
        } else if(!this.multiple && this.value && Array.isArray(this.value)) {
          this.$emit('change', this.value[0])
        }
      },
      immediate: true
    }
  }
}
</script>

<style>

</style>